export function bffRequestHeaders(currentCustomerId: number): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-CSRF': '1',
  };
  if (currentCustomerId > 0)
    headers['X-Customer-Id'] = String(currentCustomerId);
  return headers;
}
